var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserLargeBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.688,
    height: 39.643,
    viewBox: "0 0 34.688 39.643",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M115.821,9.911A9.911,9.911,0,1,1,105.911,0,9.911,9.911,0,0,1,115.821,9.911Z",
    transform: "translate(-88.567)",
    fill: "#888",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M24.281,288H22.988A13.48,13.48,0,0,1,11.7,288H10.406A10.408,10.408,0,0,0,0,298.4v3.223a3.716,3.716,0,0,0,3.717,3.716H30.971a3.716,3.716,0,0,0,3.717-3.716v-3.221A10.408,10.408,0,0,0,24.284,288Z",
    transform: "translate(0 -265.701)",
    fill: "#047BC1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserLargeBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-large-blue.0fb7cb176f0f869fdb15ee22706ab5d6.svg";